// src/assets/svg/index.js

// Import all SVGs using relative path ../assets/svg/
import Broadcast_members_img from "../assets/images/broadcast_members_img.png";
import External_Staf_img from "../assets/images/External_Staf_img.png";
import Profileimg from "../assets/images/Profileimg.png";
import Profileimg1 from "../assets/images/Profileimg1.png";
import PatientImg from "../assets/images/PatientImg.png";
import DirectMessageImg from "../assets/images/DirectMessageImg.png";
import MapImg from "../assets/images/MapImg.png";
import MapChatImg from "../assets/images/MapChatImg.png";


import img1 from "../assets/images/PatientsImages/img1.png";
import img2 from "../assets/images/PatientsImages/img2.png";
import img3 from "../assets/images/PatientsImages/img3.png";
import img4 from "../assets/images/PatientsImages/img4.png";
import img5 from "../assets/images/PatientsImages/img5.png";
import img6 from "../assets/images/PatientsImages/img6.png";

import Active from "../assets/svg/Active.svg";
import Bell from "../assets/svg/Bell.png";
import BellBlue from "../assets/svg/BellBlue.svg";
import AlertIcon from "../assets/svg/AlertIcon.svg";
import Deactivate from "../assets/svg/deactivate.svg";
import DeactivateModalIcon from "../assets/svg/deactivateModalIcon.svg";
import DeactivateSimple from "../assets/svg/deactivateSimple.svg";
import Delete from "../assets/svg/delete.svg";
import DeleteModalIcon from "../assets/svg/DeleteModalIcon.svg";
import DeleteModalIcon1 from "../assets/svg/DeleteModalIcon1.svg";
import UnarchiveModalIcon from "../assets/svg/UnarchiveModalIcon.svg";
import TransferIcon from "../assets/svg/Transfer.svg";
import ArchieveIcon from "../assets/svg/Archieve.svg";
import UnarchieveIcon from "../assets/svg/Unarchieve.svg";
import ArchiveModalIcon from "../assets/svg/ArchiveModalIcon.svg";
import Draft from "../assets/svg/Draf.svg";
import Edit from "../assets/svg/edit.svg";
import Eye from "../assets/svg/eye.svg";
import UnReadMsg from "../assets/svg/UnReadMsg.svg";
import ReadMessage from "../assets/svg/ReadMessage.svg";
import Filter from "../assets/svg/Filter.svg";
import Info from "../assets/svg/info.svg";
import Invited from "../assets/svg/Invited.svg";
import LocationSettingIcon1 from "../assets/svg/location_setting_icon1.svg";
import LocationSettingIcon2 from "../assets/svg/location_setting_icon2.svg";
import LocationSettingIcon3 from "../assets/svg/location_setting_icon3.svg";
import LocationSettingIcon4 from "../assets/svg/location_setting_icon4.svg";
import LocationSettingIcon5 from "../assets/svg/location_setting_icon5.svg";
import LocationSettingIcon6 from "../assets/svg/location_setting_icon6.svg";
import LocationSettingIcon7 from "../assets/svg/location_setting_icon7.svg";
import LocationSettingIcon8 from "../assets/svg/location_setting_icon8.svg";
import Logo from "../assets/svg/logo.svg";
import Plus from "../assets/svg/Plus.svg";
import PlusBlue from "../assets/svg/PlusBlue.svg";
import PlusBlack from "../assets/svg/PlusBlack.svg";
import PlusGray from "../assets/svg/PlusGray.svg";
import RemoveAccess from "../assets/svg/RemoveAccess.svg";
import ThreeDots from "../assets/svg/ThreeDots.svg";
import Check from "../assets/svg/check.svg";
import CheckBlack from "../assets/svg/CheckBlack.svg";
import Copy from "../assets/svg/Copy.svg";
import Report from "../assets/svg/Report.svg";
import GreenDot from "../assets/svg/GreenDot.svg";
import UpdateStatus from "../assets/svg/UpdateStatus.svg";
import ViewChannel from "../assets/svg/ViewChannel.svg";
import AddEmoji from "../assets/svg/AddEmoji.svg";
import RemoveLater from "../assets/svg/RemoveLater.svg";
import House from "../assets/svg/House.svg";
import HouseFill from "../assets/svg/HouseFill.svg";
import Users from "../assets/svg/Users.svg";
import AddUsers from "../assets/svg/AddUsers.svg";
import AddUsersBlue from "../assets/svg/AddUsersBlue.svg";
import UsersDark from "../assets/svg/UsersDark.svg";
import Notepad from "../assets/svg/Notepad.svg";
import Pinned from "../assets/svg/Pinned.svg";

import MemberTypeExternalStaff from "../assets/svg/MemberTypeExternalStaff.svg";
import MemberTypeExternalStaffBlue from "../assets/svg/MemberTypeExternalStaffBlue.svg";
import MemberTypeExternalStaffStatus from "../assets/svg/MemberTypeExternalStaffGreen.svg";
import MemberTypePatientFamily from "../assets/svg/MemberTypePatientFamily.svg";
import MemberTypeStaff from "../assets/svg/MemberTypeStaff.svg";
import MemberTypeStaffStatus from "../assets/svg/MemberTypeStaffStatus.svg";
import MemberTypeInvite from "../assets/svg/MemberTypeInvite.svg";
import MemberTypeInviteStatus from "../assets/svg/MemberTypeInviteStatus.svg";
import MemberTypeInviteBlue from "../assets/svg/MemberTypeInviteBlue.svg";
import MemberTypeLocationPartner from "../assets/svg/MemberTypeLocationPartner.svg";
import MemberTypeLocationPartnerStatus from "../assets/svg/MemberTypeLocationPartnerStatus.svg";

import Attherate from "../assets/svg/Attherate.svg";
import PhonePlus from "../assets/svg/PhonePlus.svg";
import Flag from "../assets/svg/Flag.svg";
import BroadCast from "../assets/svg/BroadCast.svg";
import Replied from "../assets/svg/Replied.svg";
import RepliedWithbg from "../assets/svg/RepliedWithbg.svg";

import ReplayDark from "../assets/svg/ReplayDark.svg";
import SaveLater from "../assets/svg/SaveLater.svg";
import Forward from "../assets/svg/Forward.svg";
import PinnedDark from "../assets/svg/PinnedDark.svg";
import UnPinnedDark from "../assets/svg/UnPinnedDark.svg";
import MessageDetails from "../assets/svg/MessageDetails.svg";
import CopyDark from "../assets/svg/CopyDark.svg";
import DeleteRed from "../assets/svg/DeleteRed.svg";

import Security from "../assets/svg/Security.svg";
import SecurityBlue from "../assets/svg/SecurityBlue.svg";
import OutOfOffice from "../assets/svg/OutOfOffice.svg";
import OutOfOfficeBlue from "../assets/svg/OutOfOfficeBlue.svg";
import ResendMessage from "../assets/svg/ResendMessage.svg";
import ResendMessageBlue from "../assets/svg/ResendMessageBlue.svg";
import Profile from "../assets/svg/Profile.svg";
import ProfileBlue from "../assets/svg/ProfileBlue.svg";
import ProfileIcon from "../assets/svg/ProfileIcon.svg";
import Arrowdown from "../assets/svg/Arrowdown.svg";

import PerPage from "../assets/svg/PerPage.svg";
import ArrowLeft from "../assets/svg/ArrowLeft.svg";
import ArrowRight from "../assets/svg/ArrowRight.svg";
import Cross from "../assets/svg/Cross.svg";
import Attachment from "../assets/svg/Attachment.svg";
import Clock from "../assets/svg/Clock.svg";
import PdfIcon from "../assets/svg/PdfIcon.svg";
import Download from "../assets/svg/Download.svg";
import File from "../assets/svg/File.svg";
import ResendInvitation from "../assets/svg/ResendInvitation.svg";

import AttherateDark from "../assets/svg/AttherateDark.svg";
import ChooseFile from "../assets/svg/ChooseFile.svg";
import Hash from "../assets/svg/Hash.svg";
import FlagDark from "../assets/svg/FlagDark.svg";
import SendMessageAgain from "../assets/svg/SendMessageAgain.svg";
import FemaleAvatar from "../assets/svg/FemaleAvatar.svg";
import LocationIcon from "../assets/svg/LocationIcon.svg";
import CompleteClock from "../assets/svg/CompleteClock.svg";
import SendMessageIcon from "../assets/svg/SendMessageIcon.svg";
import CalendarIcon from "../assets/svg/CalendarIcon.svg";
import CalendarIcon1 from "../assets/svg/CalendarIcon1.svg";
import VoiceIcon from "../assets/svg/VoiceIcon.svg";

// SideBar Icons
import AllExternalStaff from "../assets/svg/SideBar/AllExternalStaff.svg";
import AllPatientFamily from "../assets/svg/SideBar/AllPatientFamily.svg";
import AllStaff from "../assets/svg/SideBar/AllStaff.svg";
import Assessment from "../assets/svg/SideBar/Assessment.svg";
import BackArrow from "../assets/svg/SideBar/BackArrow.svg";
import Billing from "../assets/svg/SideBar/Billing.svg";
import Broadcasting from "../assets/svg/SideBar/Broadcasting.svg";
import Dashboard from "../assets/svg/SideBar/Dashboard.svg";
import Flags from "../assets/svg/SideBar/Flags.svg";
import Location from "../assets/svg/SideBar/Location.svg";
import Members from "../assets/svg/SideBar/Members.svg";
import Notification from "../assets/svg/SideBar/Notification.svg";
import Organization from "../assets/svg/SideBar/Organization.svg";
import PartnerLocation from "../assets/svg/SideBar/PartnerLocation.svg";
import Patients from "../assets/svg/SideBar/Patients.svg";
import Permission from "../assets/svg/SideBar/Permission.svg";
import Reporting from "../assets/svg/SideBar/Reporting.svg";
import Request from "../assets/svg/SideBar/Request.svg";

import Help from "../assets/svg/SideBar/Help.svg";
import Admin from "../assets/svg/SideBar/Admin.svg";
import MaleAvatar from "../assets/svg/SideBar/MaleAvatar.svg";

// All Icons Object
const AllIcons = {

  Broadcast_members_img,
  External_Staf_img,
  Profileimg,
  Profileimg1,
  PatientImg,
  DirectMessageImg,
  MapImg,
  MapChatImg,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,

  Active,
  Bell,
  BellBlue,
  AlertIcon,
  Deactivate,
  DeactivateModalIcon,
  DeactivateSimple,
  Delete,
  DeleteModalIcon,
  UnarchiveModalIcon,
  TransferIcon,
  ArchieveIcon,
  UnarchieveIcon,
  ArchiveModalIcon,
  DeleteModalIcon1,
  Draft,
  Edit,
  Eye,
  UnReadMsg,
  ReadMessage,
  Filter,
  Info,
  Invited,
  LocationSettingIcon1,
  LocationSettingIcon2,
  LocationSettingIcon3,
  LocationSettingIcon4,
  LocationSettingIcon5,
  LocationSettingIcon6,
  LocationSettingIcon7,
  LocationSettingIcon8,
  Logo,
  Plus,
  PlusBlue,
  PlusGray,
  PlusBlack,
  RemoveAccess,
  ThreeDots,
  Check,
  CheckBlack,
  Copy,
  Report,
  GreenDot,
  UpdateStatus,
  Security,
  SecurityBlue,
  OutOfOffice,
  OutOfOfficeBlue,
  ResendMessage,
  ResendMessageBlue,
  SendMessageAgain,
  FemaleAvatar,
  LocationIcon,
  CompleteClock,
  CalendarIcon,
  CalendarIcon1,
  SendMessageIcon,
  VoiceIcon,
  Profile,
  ProfileBlue,
  ProfileIcon,
  Arrowdown,
  PerPage,
  ArrowLeft,
  ArrowRight,
  Cross,
  Attachment,
  Clock,
  PdfIcon,
  Download,
  File,
  ResendInvitation,
  AttherateDark,
  ChooseFile,
  Hash,
  FlagDark,
  ResendMessage,
  Attherate,
  PhonePlus,
  Flag,
  Replied,
  RepliedWithbg,

  ReplayDark,
  SaveLater,
  Forward,
  PinnedDark,
  UnPinnedDark,
  MessageDetails,
  CopyDark,
  DeleteRed,

  BroadCast,
  ViewChannel,
  AddEmoji,
  RemoveLater,
  House,
  HouseFill,
  Users,
  AddUsers,
  AddUsersBlue,
  UsersDark,
  Notepad,
  Pinned,

  MemberTypeExternalStaff,
  MemberTypeExternalStaffBlue,
  MemberTypeExternalStaffStatus,
  MemberTypePatientFamily,
  MemberTypeStaff,
  MemberTypeStaffStatus,
  MemberTypeInvite,
  MemberTypeInviteStatus,
  MemberTypeInviteBlue,
  MemberTypeLocationPartner,
  MemberTypeLocationPartnerStatus,
  // SideBar Icons
  AllExternalStaff,
  AllPatientFamily,
  AllStaff,
  Assessment,
  BackArrow,
  Billing,
  Broadcasting,
  Dashboard,
  Flags,
  Location,
  Members,
  Notification,
  Organization,
  PartnerLocation,
  Patients,
  Permission,
  Reporting,
  Request,
  Help,
  Admin,
  MaleAvatar,
};

export default AllIcons;
